// extracted by mini-css-extract-plugin
module.exports = {"accessDenied":"AccessDeniedPage_accessDenied__13EXX","icon":"AccessDeniedPage_icon__oPLbF","title":"AccessDeniedPage_title__2X3-W"};